import { type ComponentProps } from "react";

export const Players = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.95794 2.74219C10.4309 2.74219 12.421 4.73125 12.421 7.20525C12.421 9.6248 10.4319 11.6683 7.95794 11.6683C5.48497 11.6683 3.49487 9.6248 3.49487 7.20525C3.49487 4.73228 5.48393 2.74219 7.95794 2.74219ZM7.95794 4.3018C6.34491 4.3018 5.05448 5.59222 5.05448 7.20525C5.05448 8.81828 6.34491 10.1087 7.95794 10.1087C9.57097 10.1087 10.8614 8.81828 10.8614 7.20525C10.8614 5.59222 9.57097 4.3018 7.95794 4.3018Z"
      fill="#6D777C"
    />
    <path
      d="M1.39971 17.6356C1.18498 18.0116 0.701077 18.1195 0.378471 17.8503C0.00244126 17.6356 -0.105438 17.1517 0.109288 16.7746C1.88362 14.1404 4.78708 12.5273 7.95972 12.5273C11.1324 12.5273 14.0892 14.1404 15.8102 16.7746C16.0249 17.1507 15.918 17.6346 15.5954 17.8503C15.2194 18.1195 14.7355 18.0117 14.5197 17.6356C13.068 15.4308 10.595 14.0869 7.95971 14.0869C5.32544 14.0869 2.85144 15.4308 1.39971 17.6356Z"
      fill="#6D777C"
    />
    <path
      d="M17.8525 0C20.3254 0 22.3155 1.98906 22.3155 4.46306C22.3155 6.93603 20.3265 8.92613 17.8525 8.92613C15.3795 8.92613 13.3894 6.88261 13.3894 4.46306C13.3894 1.99009 15.3785 0 17.8525 0ZM17.8525 1.55961C16.2394 1.55961 14.949 2.85003 14.949 4.46306C14.949 6.0761 16.2394 7.36652 17.8525 7.36652C19.4655 7.36652 20.7559 6.0761 20.7559 4.46306C20.7559 2.85003 19.4655 1.55961 17.8525 1.55961Z"
      fill="#6D777C"
    />
    <path
      d="M13.659 12.5818C13.3364 12.7965 12.8525 12.6896 12.6378 12.3126C12.3686 11.99 12.4765 11.5061 12.8525 11.2369C14.3577 10.3225 16.0786 9.78516 17.8529 9.78516C21.0256 9.78516 23.9824 11.3982 25.7034 14.0325C25.9181 14.4085 25.8112 14.8924 25.4886 15.1082C25.1126 15.3773 24.6287 15.2695 24.4129 14.8934C22.9612 12.6886 20.4882 11.3448 17.8529 11.3448C16.3478 11.3448 14.9495 11.7752 13.659 12.5818Z"
      fill="#6D777C"
    />
  </svg>
);
